

    
    <!-- The modal -->
    <div class="modal fade" id="flipFlop" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
    <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
    <span aria-hidden="true">&times;</span>
    </button>
   
    </div>
    <div class="modal-body">
        <iframe width="748" height="420" src="https://www.youtube.com/embed/DJi7-ah1Ilc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    
    </div>
    </div>
    </div>
<div id="myCarousel" class="carousel slide" data-ride="carousel">
    <!-- Indicators -->
    <ol class="carousel-indicators">
      <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
      <li data-target="#myCarousel" data-slide-to="1"></li>
      <li data-target="#myCarousel" data-slide-to="2"></li>
      <li data-target="#myCarousel" data-slide-to="3"></li>
    </ol>

    <!-- Wrapper for slides -->
    <div class="carousel-inner" role="listbox">
      <div class="item active">
        <img src="../assets/slide02.jpg" >
        <div class="carousel-caption">
          <div class="back">
          <h1>Your Way to <span style="color:#4c3180;">w</span>Health!</h1>
          <h2>What You Eat Matters!</h2>
          
          
          <p>
            <!-- <button type="button" class="btn btn-secondary px-4 py-3 mt-3 btn-video video" data-toggle="modal" data-target="#flipFlop">
                <img src="../assets/play_icon.png" alt="play_icon" class="videoimg">&nbsp;Watch Video
            </button> -->
           
          
          </p>
        </div>
        </div>      
      </div>

      <div class="item">
          
        <img src="../assets/slide04.jpg"  >
      
        <div class="carousel-caption">
            <div class="back">
            <h1>Your Way to <span style="color:#4c3180;">w</span>Health!</h1>
            <h2>Achieve Optimum Health!</h2>
            
            
            <p>
              <!-- <button type="button" class="btn btn-secondary px-4 py-3 mt-3 btn-video video" data-toggle="modal" data-target="#flipFlop">
                  <img src="../assets/play_icon.png" alt="play_icon" class="videoimg">&nbsp;Watch Video
              </button> -->
             
            
            </p>
          </div>
          </div>      
      </div>
    
     
       
      <div class="item">
        <img src="../assets/slide01.jpg" >
      
            <div class="carousel-caption">
                <div class="back">
                <h1>Your Way to <span style="color:#4c3180;">w</span>Health!</h1>
                <h2>Your Wellness is in Your Hands!</h2>
                
                
                <p>
                  <!-- <button type="button" class="btn btn-secondary px-4 py-3 mt-3 btn-video video" data-toggle="modal" data-target="#flipFlop">
                      <img src="../assets/play_icon.png" alt="play_icon" class="videoimg">&nbsp;Watch Video
                  </button> -->
                 
                
                </p>
              
              </div>   
          </div>      
      </div>
       
      <div class="item">
        <img src="../assets/slide03.jpg" >
        <div class="carousel-caption">
            <div class="back">
            <h1>Your Way to <span style="color:#4c3180;">w</span>Health!</h1>
            <h2>Fitness is a Game Changer!</h2>
            
            
            <p>
              <!-- <button type="button" class="btn btn-secondary px-4 py-3 mt-3 btn-video video" data-toggle="modal" data-target="#flipFlop">
                  <img src="../assets/play_icon.png" alt="play_icon" class="videoimg">&nbsp;Watch Video
              </button> -->
             
            
            </p>
          </div>
          </div>     
      </div>
      <div class="item">
        <img src="../assets/slide02.jpg"  >
      
          <div class="carousel-caption align-items-center justify-content-center">
            <div class="back">
            <h1>Your Way to <span style="color:#4c3180;">w</span>Health!</h1>
            <h2>Fitness is a Game Changer!</h2>
            <p>
                <!-- <button type="button" class="btn btn-secondary px-4 py-3 mt-3 btn-video video" data-toggle="modal" data-target="#flipFlop">
                    <img src="../assets/play_icon.png" alt="play_icon" class="videoimg">&nbsp;Watch Video
                    </button> -->
               
              
              </p>
          </div>
          </div>  
        
      </div>
    </div>

    <!-- Left and right controls -->
    <a class="left carousel-control" href="#myCarousel" role="button" data-slide="prev">
      <!-- <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> -->
      <span class="sr-only">Previous</span>
    </a>
    <a class="right carousel-control" href="#myCarousel" role="button" data-slide="next">
      <!-- <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span> -->
      <span class="sr-only">Next</span>
    </a>
</div>
<section class="ftco-section ftco-no-pt ftc-no-pb section-ahyush-caring">
    <div class="container-fluid c">
        <div class="container">
            <div class="row-content">
                <h1 class="mt-5 mb-4"><span>{{brandData?.brandName}}</span><br>  Life Sciences – Caring for You!</h1>
                <p>'{{brandData?.brandName}}' means life or vital power in Sanskrit. So, true to its name, {{brandData?.brandName}} Life Sciences is the place where you get a new meaning to wellness as we enhance the quality of your life and add positive value to it! At {{brandData?.brandName}} Life Sciences, our culture focuses on overall well-being through assessing, bringing awareness, motivating, intervening and mitigating.  
                </p>
            </div>
            <a type="button" class="bb2 lives" href={{wellnessUrl}}  target="_blank">Learn More <i class="bi bi-chevron-double-right"></i></a>
        </div>
    </div>
</section>


<section class="ftco-section ftco-no-pt ftc-no-pb section-employers">
    <div class="container">
    <ul class="nav nav-pills">
        <li class="active"><a data-toggle="pill" href="#home">Members
        </a></li>
        <li><a data-toggle="pill" href="#menu1">Wellness Managers
        </a></li>
        
      </ul>
    </div>
    <div class="container">
      
      <div class="tab-content">
        <div id="home" class="tab-pane fade in active">
            <div class="container">
                <div class="col-lg-6 col-md-6 col-sm-12">
             
                    <!-- <a data-toggle="tab" href="#employees" data-index="0" class="show active"><img src="images/home/tab_employees_active.png"></a> -->
                
              <img src="../assets/employee.jpg" width="100%"  />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="ahy-content" style="padding-left:10px;">
                <h1 class="mt-3 mb-4">{{brandData?.brandName}} Life Sciences for Members</h1>
                <p>We at {{brandData?.brandName}} Life Sciences start with assessing your health and plunge into a wellness journey that helps you get into optimal health. Our journeys are tailor-made for you, as our focus is on risk-specific goals based on every individual, which becomes a stepping stone in achieving health goals. All your efforts are assessed and rewarded, which is the icing on the cake! 
                </p>						
                <!-- <a href="product-overview" class="btn-more mt-4">Learn More</a> -->
                </div>
            
            </div>
          </div>
        </div>
        <div id="menu1" class="tab-pane fade">
            <div class="container">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <!-- <a data-toggle="tab" href="#employers" data-index="1" class="show active"><img src="assets/img/tab_employers_active.png"></a> -->
              <img src="../assets/employers.png" width="100%"  />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="ahy-content" style="padding-left:10px;">
                <h1 class="mt-3 mb-4">{{brandData?.brandName}} Life Sciences for Wellness Manager</h1>
                <p>While members gain with {{brandData?.brandName}} Life Sciences’ wellness packages, our Wellness Managers overview ensures that your wellness is managed most effectively. We aim to create an aware and motivated healthy environment for you. 
                </p>
                
                </div>
            </div>
          </div>
        </div>
      
      
      </div>
    
    </div>

</section>




<section class="ftco-section ftco-no-pt ftc-no-pb section-ahyush-caring">
  <div class="container-fluid c">
    <h1 class="mb-4">What {{brandData?.brandName}} Life Sciences Offers</h1>

    <p class="fsize22">How We Make a Difference?
    </p>
  
  <div class="col-md-4 col-sm-6 mb-5">
    <div class="offerDiv text-center">
      <img src="../assets/health-assessment.png">
      <h2 class="mt-5 mb-3">Health Assessment</h2>
      <p>Awareness is the first step to a healthy life.</p>
    </div>
  </div>
  <div class="col-md-4 col-sm-6 mb-5">
    <div class="offerDiv text-center">
      <img src="../assets/personalised-wellness.png">
      <h2 class="mt-5 mb-3">Personalized Wellness Solution</h2>
      <p>We understand that there is no 'one-size-fits-all' solution in the wellness stream.</p>
    </div>
  </div>
  <div class="col-md-4 col-sm-6 mb-5">
    <div class="offerDiv text-center">
      <img src="../assets/user-engagement.png">
      <h2 class="mt-5 mb-3">User Engagement</h2>
      <p>We keep you at it constantly by offering the right info at the right time!

      </p>
    </div>
  </div>
 <div class="container">
  <div class="col-md-6 col-sm-6 mb-5">
    <div class="offerDiv text-center">
      <img src="../assets/perks-incentive.png">
      <h2 class="mt-5 mb-3">Incentives</h2>
      <p>Everyone needs recognition for positive behaviour every once in a while! Our rewards module allows that!
      </p>
    </div>
  </div>
  <div class="col-md-6 col-sm-6 mb-5">
    <div class="offerDiv text-center">
      <img src="../assets/reports-insights.png">
      <h2 class="mt-5 mb-3">Reports &amp; Insights</h2>
      <p>Our constant monitoring and health insights help you understand your stance healthwise.
 
      </p>
    </div>
  </div>
</div>
</div>
</section>





<section class="ftco-section ftco-no-pt ftc-no-pb section-why-ahyush">
  <div class="container">
    <div class="row mt-5">
      <div class="col-md-6">						
        
        <h1 class="topline mt-5 mb-4">Why {{brandData?.brandName}} Life Sciences</h1>
        <p class="">What Makes {{brandData?.brandName}} Life Sciences Click?<br>In simple words, we are your much-needed guide to wellness!</p>
        <ul class="ul">
          <li><span  class="glyphicon glyphicon-triangle-right"></span>An effective wellness management platform in the digital route</li>
          <li><span  class="glyphicon glyphicon-triangle-right"></span>Customised plans to enhance the quality of  your life
          </li>
          <li><span  class="glyphicon glyphicon-triangle-right"></span>Special personalised health assessment methodology designed by World Renowned Hospital-based research institute</li>
          <li><span  class="glyphicon glyphicon-triangle-right"></span>Top-notch User Experience. 
          </li>
        </ul>						
      </div>
      <div class="col-md-6">
        <img class="why-ahyush-img" class="img" src="../assets/why-ahyush.jpg" alt="Why Ahyush" width="100%">
      </div>					
    </div>
  </div>
</section>








